<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header 
    [currentUser]="currentUser" 
    (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav 
      [isMobileMenuOpen]="isMobileMenuOpen"
      (navigate)="onNavigate($event)"
      (mobileMenuClose)="closeMobileMenu()"
      (desktopSidebarToggle)="onDesktopSidebarToggle($event)">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main" [class.sidebar-collapsed]="isDesktopSidebarCollapsed">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <h1 class="page-title">จัดการผู้ใช้งาน</h1>
          <p class="page-subtitle">ระบบจัดการข้อมูลผู้ใช้งาน VAT</p>
        </div>

        <!-- Mock Data Warning -->
        <ngb-alert 
          *ngIf="showMockDataWarning" 
          type="info" 
          [dismissible]="false"
          class="mb-3">
          <strong>ข้อมูลตัวอย่าง:</strong> 
          ระบบกำลังใช้ข้อมูลตัวอย่างเนื่องจากไม่สามารถเชื่อมต่อ backend API ได้
        </ngb-alert>

        <!-- Error Alert -->
        <ngb-alert 
          *ngIf="error" 
          type="danger" 
          [dismissible]="true"
          class="mb-3">
          {{ error }}
        </ngb-alert>

        <!-- Status Tabs -->
        <div class="status-tabs-container">
          <div class="status-tabs">
            <button 
              *ngFor="let tab of tabs"
              type="button"
              class="status-tab"
              [class.active]="activeTab === tab.id"
              (click)="switchTab(tab.id)">
              <span class="tab-label">{{ tab.label }}</span>
              <span class="tab-badge" [ngClass]="tab.badgeClass">
                {{ getTabCount(tab.id) }}
              </span>
            </button>
          </div>
        </div>

        <!-- Filters Section -->
        <div class="filters-section">
          <div class="filters-header">
            <h3>ตัวกรอง</h3>
            <button 
              type="button" 
              class="clear-filters-btn" 
              (click)="clearFilters()">
              ล้างตัวกรอง
            </button>
          </div>
          
          <div class="filters-grid">
            <!-- Search Term -->
            <div class="filter-group">
              <label class="form-label">ค้นหาทั่วไป</label>
              <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="filters.searchTerm" 
                (ngModelChange)="applyFilters()"
                placeholder="ชื่อ, อีเมล หรือ ID Card">
            </div>

            <!-- CID Search -->
            <div class="filter-group">
              <label class="form-label">ID Card No.</label>
              <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="filters.cidSearch" 
                (ngModelChange)="applyFilters()"
                placeholder="เลขบัตรประชาชน">
            </div>

            <!-- Organization -->
            <div class="filter-group">
              <label class="form-label">หน่วยงาน/สังกัด</label>
              <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="filters.organization" 
                (ngModelChange)="applyFilters()"
                placeholder="ชื่อหน่วยงาน">
            </div>

            <!-- VAT Member Type -->
            <div class="filter-group">
              <label class="form-label">ประเภทสมาชิก VAT</label>
              <select 
                class="form-select" 
                [(ngModel)]="filters.vatMemberType" 
                (ngModelChange)="applyFilters()"
                [disabled]="isLoadingLicenses">
                <option value="">{{ isLoadingLicenses ? 'กำลังโหลด...' : 'ทั้งหมด' }}</option>
                <option 
                  *ngFor="let license of licenses" 
                  [value]="license.licenseType">
                  {{ license.name }}
                </option>
              </select>
            </div>

            <!-- Rank Level -->
            <div class="filter-group">
              <label class="form-label">ระดับตำแหน่ง</label>
              <select 
                class="form-select" 
                [(ngModel)]="filters.rankLevel" 
                (ngModelChange)="applyFilters()"
                [disabled]="isLoadingRanks">
                <option value="">{{ isLoadingRanks ? 'กำลังโหลด...' : 'ทั้งหมด' }}</option>
                <option 
                  *ngFor="let rank of ranks" 
                  [value]="rank.level">
                  {{ rank.name }}
                </option>
              </select>
            </div>

            <!-- Status -->
            <div class="filter-group">
              <label class="form-label">สถานะ</label>
              <select 
                class="form-select" 
                [(ngModel)]="filters.status" 
                (ngModelChange)="applyFilters()">
                <option value="all">ทั้งหมด</option>
                <option value="active">ใช้งาน</option>
                <option value="inactive">ไม่ใช้งาน</option>
              </select>
            </div>

            <!-- Quick Filters -->
            <div class="filter-group">
              <label class="form-label">ตัวกรองเร็ว</label>
              <div class="d-flex gap-2">
                <button 
                  type="button" 
                  class="btn btn-sm"
                  [class.btn-warning]="filters.vatExpiring"
                  [class.btn-outline-warning]="!filters.vatExpiring"
                  (click)="filters.vatExpiring = !filters.vatExpiring; applyFilters()">
                  VAT หมดอายุ
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm"
                  [class.btn-danger]="filters.valuerExpiring"
                  [class.btn-outline-danger]="!filters.valuerExpiring"
                  (click)="filters.valuerExpiring = !filters.valuerExpiring; applyFilters()">
                  Valuer หมดอายุ
                </button>
              </div>
            </div>
          </div>
          
                  <!-- Action Buttons -->
        <div class="d-flex gap-2 mt-3">
          <button 
            type="button" 
            class="btn btn-outline-success" 
            (click)="exportToCSV()"
            [disabled]="filteredUsers.length === 0">
            <i class="bi bi-file-earmark-excel me-2"></i>Export CSV
          </button>
          <button 
            type="button" 
            class="btn btn-primary" 
            (click)="refreshData()">
            <i class="bi bi-arrow-clockwise me-2"></i>รีเฟรชข้อมูล
          </button>
        </div>
        </div>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="user-management-container">
          <div class="loading-state">
            <div class="loading-spinner"></div>
            <p>กำลังโหลดข้อมูลผู้ใช้งาน...</p>
          </div>
        </div>

        <!-- Users Table -->
        <div class="card" *ngIf="!isLoading">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">รายการผู้ใช้งาน</h5>
            <div class="d-flex align-items-center gap-2">
              <span class="text-muted">แสดงผล:</span>
              <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize"
                  (ngModelChange)="changePageSize(pageSize)" aria-label="จำนวนรายการต่อหน้า">
                  <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} รายการ</option>
                </select>
            </div>
          </div>

          <div class="card-body p-0">
            <!-- Table -->
            <div class="table-responsive">
              <table class="table table-striped table-hover mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col" class="sortable" (click)="sortBy('name')">
                      ชื่อ-สกุล {{ getSortIcon('name') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('cid')">
                      ID Card No. {{ getSortIcon('cid') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('organization')">
                      หน่วยงาน/สังกัด {{ getSortIcon('organization') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('vatId')">
                      VAT ID {{ getSortIcon('vatId') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('vatExpired')">
                      VAT Expired {{ getSortIcon('vatExpired') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('valuerId')">
                      Valuer ID {{ getSortIcon('valuerId') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('valuerExpired')">
                      Valuer Expired {{ getSortIcon('valuerExpired') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('verificationStatus')">
                      สถานะการตรวจสอบ {{ getSortIcon('verificationStatus') }}
                    </th>
                    <th scope="col" class="text-center">สถานะ</th>
                    <!-- <th scope="col" class="text-center">จัดการ</th> -->
                  </tr>
                </thead>
                <tbody>
                  <!-- No Data Row -->
                  <tr *ngIf="!isLoading && getCurrentPageUsers().length === 0">
                    <td colspan="10" class="text-center py-4">
                      <div class="text-muted">
                        <i class="bi bi-inbox"></i>
                        <p class="mb-0">ไม่พบข้อมูลผู้ใช้งาน</p>
                        <small *ngIf="users.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small *ngIf="users.length > 0 && filteredUsers.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                      </div>
                    </td>
                  </tr>

                  <!-- User Rows -->
                  <tr *ngFor="let user of getCurrentPageUsers(); trackBy: trackByUserId" 
                      class="clickable-row" 
                      (click)="openUserDetailModal(user)"
                      title="คลิกเพื่อดูรายละเอียดผู้ใช้งาน">
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="flex-grow-1">
                          <h6 class="mb-0">{{ user.userInformation?.firstName }} {{ user.userInformation?.lastName }}</h6>
                          <small class="text-muted">{{ user.email }}</small>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span class="font-monospace">{{ user.cid }}</span>
                    </td>
                    <td>
                      <span [ngbTooltip]="user.userInformation?.company?.organizationName">
                        {{ user.userInformation?.company?.organizationName || '-' }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="badge"
                        [class.bg-secondary]="!getVATExpirationStatus(user)"
                        [class.bg-success]="getVATExpirationStatus(user) === 'valid'"
                        [class.bg-warning]="getVATExpirationStatus(user) === 'expiring-warning'"
                        [class.bg-danger]="getVATExpirationStatus(user) === 'expiring-soon' || getVATExpirationStatus(user) === 'expired'">
                        {{ user.userInformation?.vatId || '-' }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="badge"
                        [class.bg-secondary]="!getVATExpirationStatus(user)"
                        [class.bg-success]="getVATExpirationStatus(user) === 'valid'"
                        [class.bg-warning]="getVATExpirationStatus(user) === 'expiring-warning'"
                        [class.bg-danger]="getVATExpirationStatus(user) === 'expiring-soon' || getVATExpirationStatus(user) === 'expired'">
                        {{ getVATExpiryText(user) }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="badge"
                        [class.bg-secondary]="!getValuerExpirationStatus(user)"
                        [class.bg-success]="getValuerExpirationStatus(user) === 'valid'"
                        [class.bg-warning]="getValuerExpirationStatus(user) === 'expiring-warning'"
                        [class.bg-danger]="getValuerExpirationStatus(user) === 'expiring-soon' || getValuerExpirationStatus(user) === 'expired'">
                        {{ user.userInformation?.valuerId || '-' }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="badge"
                        [class.bg-secondary]="!getValuerExpirationStatus(user)"
                        [class.bg-success]="getValuerExpirationStatus(user) === 'valid'"
                        [class.bg-warning]="getValuerExpirationStatus(user) === 'expiring-warning'"
                        [class.bg-danger]="getValuerExpirationStatus(user) === 'expiring-soon' || getValuerExpirationStatus(user) === 'expired'">
                        {{ formatDate(user.userInformation?.valuerExpired) }}
                      </span>
                    </td>
                    <td>
                      <span 
                        class="badge"
                        [ngClass]="getVerificationStatusClass(user)">
                        {{ user.userInformation?.userStatus?.name || '-' }}
                      </span>
                    </td>
                    <td class="text-center">
                      <span 
                        class="badge"
                        [class.bg-success]="user.isActive"
                        [class.bg-secondary]="!user.isActive">
                        {{ user.isActive ? 'ใช้งาน' : 'ไม่ใช้งาน' }}
                      </span>
                    </td>
                    <td class="text-center">
                      <div ngbDropdown 
                           class="d-inline-block" 
                           (click)="$event.stopPropagation()"
                           (openChange)="onDropdownOpenChange($event, user.id)"
                           placement="bottom-right">
                        <!-- <button 
                          class="btn btn-sm btn-outline-primary dropdown-toggle" 
                          type="button" 
                          id="dropdownMenuButton-{{user.id}}"
                          ngbDropdownToggle>
                          <i class="bi bi-gear me-1"></i>จัดการ
                        </button>
                        <div class="dropdown-menu dropdown-menu-end" 
                             ngbDropdownMenu 
                             [attr.aria-labelledby]="'dropdownMenuButton-' + user.id">
                          <button 
                            class="dropdown-item"
                            type="button"
                            (click)="editUser(user)">
                            <i class="bi bi-pencil-square me-2"></i>แก้ไขข้อมูล
                          </button>
                          <div class="dropdown-divider"></div>
                          <button 
                            class="dropdown-item text-danger"
                            type="button"
                            (click)="deleteUser(user)">
                            <i class="bi bi-trash me-2"></i>ลบผู้ใช้
                          </button>
                        </div> -->
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Pagination -->
          <div class="card-footer">
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-muted">
                แสดงผล {{ ((page - 1) * pageSize) + 1 }} - {{ min(page * pageSize, collectionSize) }} 
                จาก {{ collectionSize }} รายการ
              </div>
              <ngb-pagination 
                [(page)]="page" 
                [pageSize]="pageSize" 
                [collectionSize]="collectionSize"
                [maxSize]="5"
                [rotate]="true"
                [boundaryLinks]="true"
                [size]="'sm'">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 